const StrangerDrinks = ({styleDiv, styleImg}) => {
  return (
    <div style={styleDiv}>
      <img 
        src="/images/StrangerDrinksFull.png" 
        alt="Stranger Drinks Logo" 
        style={styleImg}
      />
    </div>
  )
}

export default StrangerDrinks